import LearningMapGoalHowToModal from '@/components/LearningMapGoalHowToModal';
import RadialChartComponent from '@/components/RadialChart';
import Constants from '@/Constants';
import { formatDate } from '@/services/UtilService';
import { ApplicationState } from '@/store';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import './style.scss';

const LearningMapGoal: React.FC = () => {
    const { strings, currentLearningMap } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
        currentLearningMap: state.learningMap.data.currentLearningMap,
    }));

    const [showModal, setShowModal] = useState<boolean>(false);

    const onClickGoalInfoHandler = () => {};

    const getCompletedItemsText = (): string => {
        if (currentLearningMap.totalFinishedContents) {
            if (currentLearningMap.totalFinishedContents !== 1) {
                return `${currentLearningMap.totalFinishedContents} ${strings.LEARNING_MAP.COMPLETED_ITEMS}`;
            }
            return strings.LEARNING_MAP.COMPLETED_ITEM;
        }
        return `0 ${strings.LEARNING_MAP.COMPLETED_ITEMS}`;
    };

    return (
        <div className="goal-section-container">
            <div className="title-container">
                <div className="title">
                    <span>{strings.LEARNING_MAP.GOAL}</span>
                    <i
                        className="material-icons-outlined align-top"
                        onClick={() => {
                            setShowModal(true);
                        }}
                    >
                        {Constants.icons.ERROR_OUTLINE}
                    </i>
                </div>
            </div>
            <div className="info-container">
                <div className="description">
                    <span className="totalMinutes">{`${currentLearningMap.minutes} ${strings.LEARNING_MAP.MINUTES}`}</span>
                    <span className="weeklyGoal">
                        {`${strings.LEARNING_MAP.WEEKLY_GOAL} ${formatDate(currentLearningMap.finishDate, strings._LANGUAGE, true)}`}
                    </span>
                    <div className="completedItems">
                        <i className="material-icons" onClick={onClickGoalInfoHandler}>
                            {Constants.icons.CHECK_CIRCLE}
                        </i>
                        <span>{getCompletedItemsText()}</span>
                    </div>
                </div>
                <div className="chart">
                    <RadialChartComponent
                        chartType={Constants.radialChartTypes.GOAL_CHART}
                        completedItems={currentLearningMap.consumedMinutes}
                        radius={110}
                        totalItems={currentLearningMap.minutes}
                    />
                </div>

                <LearningMapGoalHowToModal handleClose={() => setShowModal(false)} showModal={showModal} />
            </div>
        </div>
    );
};

export default LearningMapGoal;
